/* eslint-disable import/max-dependencies */
// @flow
import {
  call, put, takeEvery, all,
} from "redux-saga/effects";
import type { Saga } from "redux-saga";
import { get } from "lodash";
import { addNotification } from "@fas/ui-framework/lib/redux/actions/notifications";
import { GET_WP_SAGA, WP_MOTIV_LOADING } from "../../helpers/constants";
import MotivationContentApi from "../../services/motivationContentApi";
import type { GetWpSaga } from "../../actions/createWp";
import { setWp } from "../../actions/createWp";
import type { WPFormData } from "../../containers/CreateWPMotivationContent";
import { setLoading } from "../../actions/loading";
import externalRedirect from "../../components/App/ExternalRedirect";
import { setModifiersState } from "../../actions/modifiers";
import { convertModifiersToUi, type ModifiersStateData } from "../../containers/Modifiers";
import type {
  MotivationTemplateType,
  MotivationTemplateRaw,
  MotivationTemplateDropdown,
} from "../../containers/CreateMotivationTemplate";
import { fetchMotivationTemplate } from "../../services/motivationTemplateApi";

export function* makeFetch(action: GetWpSaga): Saga<void> {
  const { id } = action;

  yield put(setLoading(WP_MOTIV_LOADING, true));
  try {
    const response = yield call(MotivationContentApi.getMotivationContentById, id);
    const {
      motivationTemplates = {},
      modifiers,
      ...rawWpItem
    }: { ...WPFormData, modifiers: * } = get(response, "data.data.0");
    const browserLanguages = get(rawWpItem, "BrowserLanguages", []);

    const motivationTemplatesState: { [MotivationTemplateType]: MotivationTemplateDropdown } = {};
    const modifiersState: { [MotivationTemplateType]: ModifiersStateData } = {};

    if (motivationTemplates) {
      const templates: MotivationTemplateRaw[] = yield all(Object.keys(motivationTemplates)
        .map((type: MotivationTemplateType) => call(fetchMotivationTemplate, motivationTemplates[type])));

      Object.keys(motivationTemplates).forEach((type, index) => {
        const template: MotivationTemplateRaw = templates[index];
        motivationTemplatesState[type] = { label: template.name, value: template.id, ...template };
        modifiersState[type] = convertModifiersToUi({ modifiers: modifiers[type], type });
      });

      yield put(setModifiersState(modifiersState));
    }

    const item: WPFormData = {
      ...rawWpItem,
      motivationTemplates: motivationTemplatesState,
      BrowserLanguages: browserLanguages.map(
        ({ id: value, language: label }) => ({ value, label })
      ),
    };
    yield put(setWp(item));
  }
  catch (error) {
    yield put(addNotification({ message: error.errorMessage, severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
    externalRedirect({ to: "/webpush" });
  }
  finally {
    yield put(setLoading(WP_MOTIV_LOADING, false));
  }
}

export default function* watchFetchWpSaga(): Saga<void> {
  yield takeEvery(GET_WP_SAGA, (makeFetch: Function));
}
